export default "__VITE_ASSET__G_uwbzCX__"